// Central content file for Samora Spaces. Structured for future CMS migration.

export const BRAND = {
    name: "Samora Spaces",
    tagline: "by Sam",
    domain: "samoraspaces.in",
    email: "sam@samoraspaces.in",
    phone: "+91 63050 56927",
    phoneRaw: "+916305056927",
    whatsapp: "916305056927",
    address: "#11, Sai Shraddha, DG Layout, Whitefield, Bengaluru",
    instagram:
        "https://www.instagram.com/samoraspaces.in?igsh=ODE5bHpydjE0Z3Z2&utm_source=qr",
    facebook: "https://facebook.com",
    youtube: "https://youtube.com",
    mapEmbed:
        "https://www.google.com/maps?q=Whitefield%20Bengaluru&output=embed",
};

export const HERO_IMAGE = "/generated/hero-living.jpg";

export const SECOND_HERO_IMAGE = "/generated/master-bedroom-suite.jpg";

export const PHILOSOPHY_IMAGE = "/generated/philosophy-detail.jpg";

export const NAV_LINKS = [
    { label: "Home", to: "/" },
    { label: "About", to: "/about" },
    { label: "Portfolio", to: "/portfolio" },
    { label: "Services", to: "/services" },
    { label: "Process", to: "/process" },
    { label: "Journal", to: "/blogs" },
    { label: "Contact", to: "/contact" },
];

export const FEATURED_PROJECTS = [
    {
        id: "the-teak-house",
        title: "The Teak House",
        category: "Villa",
        location: "Whitefield, Bengaluru",
        year: "2024",
        cover: "/generated/villa-exterior.jpg",
        summary:
            "A 4-bedroom villa reimagined around light, teak and slow living. Bespoke joinery in every room, quiet Indian craftsmanship throughout.",
        materials: [
            "Solid Teak",
            "Kota Stone",
            "Handloom Linen",
            "Brushed Brass",
        ],
        timeline: "22 weeks",
        budget: "₹ 65L – 90L",
        gallery: [
            "/generated/villa-exterior.jpg",
            "/generated/dining-room.jpg",
            "/generated/master-bedroom-suite.jpg",
        ],
    },
    {
        id: "quiet-apartment",
        title: "Quiet Apartment",
        category: "Apartment",
        location: "Prestige Lakeside, Bengaluru",
        year: "2024",
        cover: "/generated/quiet-apartment-living.jpg",
        summary:
            "A 3BHK sanctuary in soft neutrals — a home for a young family who wanted stillness, not statement.",
        materials: ["Wire-brushed Oak", "Travertine", "Wool Rugs", "Linen"],
        timeline: "14 weeks",
        budget: "₹ 32L – 48L",
        gallery: [
            "/generated/quiet-apartment-living.jpg",
            "/generated/foyer.jpg",
        ],
    },
    {
        id: "the-slow-kitchen",
        title: "The Slow Kitchen",
        category: "Kitchen",
        location: "Sarjapur, Bengaluru",
        year: "2024",
        cover: "/generated/modular-kitchen.jpg",
        summary:
            "A modular kitchen designed around ritual — rift-cut oak, honed quartz, and a quiet centre island for morning coffee. Handleless brass finger-pulls, fluted glass pantry, integrated appliances.",
        materials: ["Rift-cut Oak", "Honed Quartz", "Antique Brass", "Kota Stone"],
        timeline: "8 weeks",
        budget: "₹ 12L – 18L",
        gallery: [
            "/generated/modular-kitchen.jpg",
            "/generated/dining-room.jpg",
        ],
    },
    {
        id: "bedroom-in-cream",
        title: "Bedroom in Cream",
        category: "Bedroom",
        location: "HSR Layout, Bengaluru",
        year: "2023",
        cover: "/generated/bedroom-in-cream.jpg",
        summary:
            "A master suite in warm neutrals — bouclé, brushed plaster, and a bespoke headboard that runs wall-to-wall.",
        materials: ["Bouclé", "Lime Plaster", "Walnut"],
        timeline: "6 weeks",
        budget: "₹ 8L – 12L",
        gallery: [
            "/generated/bedroom-in-cream.jpg",
            "/generated/master-bedroom-suite.jpg",
        ],
    },
    {
        id: "studio-in-black",
        title: "Studio in Black",
        category: "Office",
        location: "Indiranagar, Bengaluru",
        year: "2023",
        cover: "/generated/studio-in-black.jpg",
        summary:
            "A creative director's private studio — a moody, tactile counterpoint to a bright home.",
        materials: ["Fumed Oak", "Ceppo Stone", "Blackened Steel"],
        timeline: "10 weeks",
        budget: "₹ 18L – 24L",
        gallery: [
            "/generated/studio-in-black.jpg",
            "/generated/home-office.jpg",
        ],
    },
    {
        id: "living-in-linen",
        title: "Living in Linen",
        category: "Living",
        location: "Koramangala, Bengaluru",
        year: "2023",
        cover: "/generated/living-in-linen-full.jpg",
        summary:
            "A double-height living room built around a low, hand-tufted seating pit and a wall of natural light.",
        materials: ["Belgian Linen", "Terrazzo", "Cane"],
        timeline: "12 weeks",
        budget: "₹ 20L – 28L",
        gallery: [
            "/generated/living-in-linen-full.jpg",
            "/generated/quiet-apartment-living.jpg",
        ],
    },
    {
        id: "fumed-oak-tv-wall",
        title: "Fumed Oak TV Wall",
        category: "Living",
        location: "Prestige Falcon City, Bengaluru",
        year: "2024",
        cover: "/generated/luxury-tv-unit.jpg",
        summary:
            "A full-wall bespoke TV composition — fluted fumed oak paneling, a floating oak shelf, a honed travertine niche and integrated cove lighting behind a walnut console.",
        materials: ["Fumed Oak Veneer", "Honed Travertine", "Brushed Brass", "Solid Walnut"],
        timeline: "5 weeks",
        budget: "₹ 6L – 9L",
        gallery: [
            "/generated/luxury-tv-unit.jpg",
            "/generated/living-in-linen-full.jpg",
        ],
    },
    {
        id: "walnut-wardrobes",
        title: "The Walnut Wardrobes",
        category: "Bedroom",
        location: "Whitefield, Bengaluru",
        year: "2024",
        cover: "/generated/cnc-wardrobes.jpg",
        summary:
            "A floor-to-ceiling master-suite wardrobe wall in warm walnut veneer with tall CNC grooved shutters, brass handleless pulls and softly lit walnut interiors.",
        materials: ["Walnut Veneer", "CNC-Grooved Shutters", "Brushed Brass", "Warm LED"],
        timeline: "6 weeks",
        budget: "₹ 7L – 10L",
        gallery: [
            "/generated/cnc-wardrobes.jpg",
            "/generated/bedroom-in-cream.jpg",
        ],
    },
    {
        id: "the-marble-washroom",
        title: "The Marble Washroom",
        category: "Villa",
        location: "Sarjapur, Bengaluru",
        year: "2024",
        cover: "/generated/luxury-washroom.jpg",
        summary:
            "A master ensuite built around a floating fluted walnut vanity, honed Carrara top with twin stone basins, a backlit halo mirror and a freestanding oval bath.",
        materials: ["Fluted Walnut Laminate", "Honed Carrara Marble", "Brushed Brass", "Micro-Cement Floor"],
        timeline: "7 weeks",
        budget: "₹ 9L – 14L",
        gallery: [
            "/generated/luxury-washroom.jpg",
            "/generated/villa-exterior.jpg",
        ],
    },
    {
        id: "master-suite",
        title: "The Master Suite",
        category: "Bedroom",
        location: "Prestige Falcon City, Bengaluru",
        year: "2024",
        cover: "/generated/master-bedroom-suite.jpg",
        summary:
            "A quiet master bedroom retreat — a wall-to-wall fluted walnut headboard, integrated reading niches, layered linen and warm brass sconces. A room that finally sleeps.",
        materials: ["Fluted Walnut", "Belgian Linen", "Brushed Brass", "Wool Rug"],
        timeline: "6 weeks",
        budget: "₹ 10L – 14L",
        gallery: [
            "/generated/master-bedroom-suite.jpg",
            "/generated/cnc-wardrobes.jpg",
        ],
    },
    {
        id: "the-mandir",
        title: "The Mandir",
        category: "Apartment",
        location: "Whitefield, Bengaluru",
        year: "2024",
        cover: "/generated/pooja-room.jpg",
        summary:
            "A serene modern pooja room — a full-height solid teak mandir with CNC jaali screens, a raised marble threshold and a single glowing diya. Ritual, drawn in wood.",
        materials: ["Solid Teak", "CNC Jaali", "Kota Stone", "Brass"],
        timeline: "4 weeks",
        budget: "₹ 3L – 5L",
        gallery: [
            "/generated/pooja-room.jpg",
            "/generated/foyer.jpg",
        ],
    },
    {
        id: "the-study",
        title: "The Study",
        category: "Office",
        location: "Sarjapur, Bengaluru",
        year: "2024",
        cover: "/generated/home-office.jpg",
        summary:
            "A private home office in a Bengaluru villa — a bespoke rift-cut oak desk facing a picture window, a full-wall oak library with warm LED and a caramel leather chair.",
        materials: ["Rift-cut Oak", "Caramel Leather", "Honed Travertine", "Brass"],
        timeline: "6 weeks",
        budget: "₹ 6L – 9L",
        gallery: [
            "/generated/home-office.jpg",
            "/generated/studio-in-black.jpg",
        ],
    },
    {
        id: "the-foyer",
        title: "The Foyer",
        category: "Apartment",
        location: "Indiranagar, Bengaluru",
        year: "2024",
        cover: "/generated/foyer.jpg",
        summary:
            "A luxury foyer as first impression — fluted walnut console wall, a sculptural brass mirror, a bespoke leather-and-oak bench beneath, and one considered ceramic vessel.",
        materials: ["Fluted Walnut", "Kota Stone", "Brushed Brass", "Leather"],
        timeline: "3 weeks",
        budget: "₹ 2L – 4L",
        gallery: [
            "/generated/foyer.jpg",
            "/generated/dining-room.jpg",
        ],
    },
    {
        id: "the-dining-room",
        title: "The Dining Room",
        category: "Living",
        location: "Whitefield, Bengaluru",
        year: "2024",
        cover: "/generated/dining-room.jpg",
        summary:
            "A live-edge walnut table for eight, a low brass-and-linen chandelier, and a fluted oak crockery unit — a dining room designed around the long, slow Indian meal.",
        materials: ["Live-Edge Walnut", "Linen Upholstery", "Fluted Oak", "Brass"],
        timeline: "5 weeks",
        budget: "₹ 5L – 8L",
        gallery: [
            "/generated/dining-room.jpg",
            "/generated/living-in-linen-full.jpg",
        ],
    },
    {
        id: "the-balcony-garden",
        title: "The Balcony Garden",
        category: "Landscape",
        location: "Prestige Falcon City, Bengaluru",
        year: "2024",
        cover: "/generated/balcony-landscape.jpg",
        summary:
            "A high-rise apartment balcony rebuilt as a slow-evening retreat — planter beds of frangipani and palms, a bespoke teak bench, cane pendant, and a linen lounger against the skyline.",
        materials: ["Solid Teak", "Micro-Cement", "Cane", "Natural Linen"],
        timeline: "3 weeks",
        budget: "₹ 3L – 6L",
        gallery: [
            "/generated/balcony-landscape.jpg",
            "/generated/villa-exterior.jpg",
        ],
    },
    {
        id: "the-walk-in-closet",
        title: "The Walk-in Closet",
        category: "Bedroom",
        location: "Sarjapur, Bengaluru",
        year: "2024",
        cover: "/generated/walk-in-closet.jpg",
        summary:
            "A private walk-in dressing room — walnut open bays, a travertine island for accessories, an arched brass mirror, and a soft skylight above. Ritualised dressing, drawn.",
        materials: ["Walnut Veneer", "Honed Travertine", "Brushed Brass", "Leather"],
        timeline: "5 weeks",
        budget: "₹ 6L – 9L",
        gallery: [
            "/generated/walk-in-closet.jpg",
            "/generated/cnc-wardrobes.jpg",
        ],
    },
    {
        id: "the-kids-room",
        title: "The Kids' Room",
        category: "Bedroom",
        location: "HSR Layout, Bengaluru",
        year: "2024",
        cover: "/generated/kids-room.jpg",
        summary:
            "A children's room that grows with the child — a low platform bed with a fluted oak headboard, a hand-painted mural, a reading nook, and a solid oak play desk under the window.",
        materials: ["Solid Oak", "Warm Linen", "Hand-Painted Mural", "Jute Rug"],
        timeline: "4 weeks",
        budget: "₹ 4L – 7L",
        gallery: [
            "/generated/kids-room.jpg",
            "/generated/bedroom-in-cream.jpg",
        ],
    },
];

export const PROJECT_CATEGORIES = [
    "All",
    "Apartment",
    "Villa",
    "Kitchen",
    "Bedroom",
    "Living",
    "Office",
    "Landscape",
];

export const SERVICES = [
    {
        title: "Residential Interiors",
        blurb: "Whole-home design, built around how you actually live.",
    },
    {
        title: "Luxury Apartments",
        blurb: "3, 4 & 5 BHK homes finished to a boutique-hotel standard.",
    },
    {
        title: "Villas",
        blurb: "Ground-up interiors for independent homes and farmhouses.",
    },
    {
        title: "Modular Kitchens",
        blurb: "Ergonomic, tactile kitchens engineered to last a decade.",
    },
    {
        title: "Wardrobes & Storage",
        blurb: "Fitted joinery that disappears into the architecture.",
    },
    {
        title: "Turnkey Interiors",
        blurb: "From empty shell to fully-styled handover — one team.",
    },
    {
        title: "Commercial Offices",
        blurb: "Studios and workplaces that feel unmistakably yours.",
    },
    {
        title: "Landscaping",
        blurb: "Balconies, terraces and courtyards designed for evenings in.",
    },
    {
        title: "Furniture Design",
        blurb: "Made-to-measure pieces, drawn and detailed in-house.",
    },
    {
        title: "False Ceiling",
        blurb: "Considered ceilings — where lighting and geometry meet.",
    },
    {
        title: "Lighting Design",
        blurb: "Layered lighting schemes that follow the sun and the mood.",
    },
    {
        title: "3D Visualization",
        blurb: "Photoreal renders so you experience the home before it exists.",
    },
];

export const WHY_POINTS = [
    { n: "01", t: "Premium Materials", d: "Sourced from makers we trust — solid wood, natural stone, real linen." },
    { n: "02", t: "Experienced Designers", d: "Every project is led personally by Sam, not handed off." },
    { n: "03", t: "Transparent Pricing", d: "Line-item quotes. No hidden costs, no last-week surprises." },
    { n: "04", t: "On-site Supervision", d: "A dedicated site lead is in your home, three days a week." },
    { n: "05", t: "Fixed Project Timeline", d: "Delivered on the date we shake hands on — or we own the delay." },
    { n: "06", t: "5-Year Warranty", d: "On all joinery, hardware and finishes we install." },
];

export const PROCESS_STEPS = [
    {
        step: "01",
        title: "Discovery Call",
        desc: "A candid conversation — about your home, your rituals and how you really live in a space.",
    },
    {
        step: "02",
        title: "Site Visit",
        desc: "We visit the property, measure everything twice, and read the light through the day.",
    },
    {
        step: "03",
        title: "Concept Design",
        desc: "Moodboards, plans, and a design language chosen only for you. No templates.",
    },
    {
        step: "04",
        title: "3D Visualization",
        desc: "Photoreal renders of every room. You walk through the home before a nail is hit.",
    },
    {
        step: "05",
        title: "Material Selection",
        desc: "In-person material sessions — you touch the timber, the stone, the linen.",
    },
    {
        step: "06",
        title: "Execution",
        desc: "Our in-house crew builds on site. Weekly check-ins, live progress log.",
    },
    {
        step: "07",
        title: "Quality Check",
        desc: "A 74-point snag list before we let you back into your home.",
    },
    {
        step: "08",
        title: "Handover",
        desc: "Styled, cleaned, and photographed. You walk in. You stay.",
    },
];

export const TESTIMONIALS = [
    {
        quote:
            "Sam didn't design us a house — he designed the way our mornings now feel. The kitchen alone changed how our family eats together.",
        author: "Aparna & Rohan",
        project: "4BHK Apartment, Whitefield",
    },
    {
        quote:
            "We walked into three studios. Only Samora Spaces asked us how we sit, how we sleep, how we host. The rest asked about our budget.",
        author: "Karthik R.",
        project: "Villa, Sarjapur",
    },
    {
        quote:
            "Every material is real. Every hinge is honest. Two years in and the home still feels like the render — maybe better.",
        author: "Meera V.",
        project: "3BHK, Prestige Lakeside",
    },
    {
        quote:
            "They gave us a timeline and they met it. In interior design in India, that alone is a form of luxury.",
        author: "Vikram & Sana",
        project: "Duplex, Indiranagar",
    },
];

export const FAQS = [
    {
        q: "What is the minimum project budget you take on?",
        a: "Our residential engagements typically start from ₹ 15 lakhs for a 3BHK apartment. Villas and turnkey projects begin around ₹ 45 lakhs. Every quote is line-itemised and shared upfront.",
    },
    {
        q: "Do you work outside Bengaluru?",
        a: "Yes. Around 30% of our work is in Hyderabad, Chennai, Goa and second homes across South India. Site supervision travels with the project.",
    },
    {
        q: "How long does a full-home interior take?",
        a: "A 3BHK typically takes 12–14 weeks from concept to handover. A villa runs 20–28 weeks depending on scope. Timelines are agreed on Day 1 and tracked weekly.",
    },
    {
        q: "How is Samora Spaces different from a design-and-build company?",
        a: "We are a boutique studio, not a factory. Sam personally leads every project, we cap our intake to a handful of homes at a time, and we own the site until handover.",
    },
    {
        q: "Do you provide 3D renders before we commit?",
        a: "Yes. Photoreal 3D visualizations are a part of every project. You experience your home before we build it — no surprises.",
    },
    {
        q: "Can I bring my own contractor or vendor?",
        a: "For turnkey projects we prefer our in-house crew, since accountability sits with us. For design-only engagements, we happily work with your team.",
    },
    {
        q: "What materials do you specify?",
        a: "We prefer honest materials — solid timber, natural stone, real linen, brushed brass, lime plaster. We avoid anything that pretends to be something else.",
    },
    {
        q: "Do you offer a warranty?",
        a: "Yes — a 5-year warranty on all joinery, hardware and finishes we install, and a lifetime service relationship on anything we've built.",
    },
    {
        q: "How does payment work?",
        a: "A four-tranche payment schedule tied to project milestones. Nothing paid upfront beyond a design retainer, everything against delivered work.",
    },
    {
        q: "Do you help with furniture and styling?",
        a: "Absolutely. Furniture design, procurement and final styling are included in every turnkey engagement. The home is photographed before you move in.",
    },
    {
        q: "Do you work on smaller projects — just a kitchen, or one room?",
        a: "Yes, we take on kitchens, primary bedrooms and libraries as standalone projects. These are our fastest engagements — typically 6–10 weeks.",
    },
    {
        q: "Can I see live projects before signing?",
        a: "Where our clients allow it, yes. We arrange private walkthroughs of past homes so you experience the craft firsthand.",
    },
    {
        q: "Is site supervision extra?",
        a: "No. A dedicated site lead is included in the turnkey fee — on your project three days a week, with a live daily photo log.",
    },
    {
        q: "How do we start?",
        a: "A 30-minute discovery call — no cost, no obligation. If we're the right studio for your home, we send a proposal within 5 working days.",
    },
    {
        q: "Do you take press or feature enquiries?",
        a: "Yes. Please write to sam@samoraspaces.in with the outline and we'll get back within 48 hours.",
    },
];

export const JOURNAL_POSTS = [
    {
        id: "quiet-luxury-india",
        title: "Quiet Luxury, Reinterpreted for the Indian Home",
        excerpt:
            "Why the loudest homes are almost never the ones you remember — and what quiet luxury actually costs.",
        image: "/generated/quiet-apartment-living.jpg",
        read: "6 min read",
        date: "November 2024",
    },
    {
        id: "kitchen-as-heart",
        title: "The Kitchen As the New Living Room",
        excerpt:
            "How ritual, not real estate, is redrawing the plans of India's most considered homes.",
        image: "/generated/modular-kitchen.jpg",
        read: "4 min read",
        date: "October 2024",
    },
    {
        id: "material-honesty",
        title: "A Note on Material Honesty",
        excerpt:
            "The one question we ask before specifying anything: is this material pretending to be something else?",
        image: "/generated/philosophy-detail.jpg",
        read: "5 min read",
        date: "September 2024",
    },
];

export const BUDGET_RANGES = [
    "₹ 15L – 25L",
    "₹ 25L – 45L",
    "₹ 45L – 75L",
    "₹ 75L – 1.25 Cr",
    "₹ 1.25 Cr +",
];

export const PROJECT_TYPES = [
    "3BHK Apartment",
    "4BHK Apartment",
    "Villa",
    "Modular Kitchen",
    "Bedroom / Suite",
    "Commercial Office",
    "Landscaping",
    "Other",
];
